import React from 'react';
import { useHistory, useParams } from 'react-router';
import { AtlassianLogo } from '@atlaskit/logo-latest';
import Button from '@atlaskit/button';
import { getProvisioningUrl } from '@css-xp/ppc-utils';
import { getRouteUrl, useApplicationContext } from '@css-xp/base';
import { routePaths } from '@css-xp/ppc-constants';
import OrderConfirmation from '../assets/order-confirmation.svg';
import './quote-order-confirmation.scss';

type ConditionalGetStartedProps =
  | {
      showProvisionSiteCTA?: false;
      onGetStarted?: never;
    }
  | {
      showProvisionSiteCTA: true | boolean;
      onGetStarted: (link: string) => void;
    };

export type OrderConfirmationProps = ConditionalGetStartedProps & {
  orderSlug: string;
  newSiteOrderId: string;
  transactionAccountId: string;
};

const getAtlassianLogo = (size: 'small' | 'medium' | 'large') => {
  return <AtlassianLogo appearance="brand" size={size} />;
};

export const OrderConfirmationDrawer = ({
  orderSlug,
  newSiteOrderId,
  transactionAccountId,
  onGetStarted,
  showProvisionSiteCTA,
}: OrderConfirmationProps) => {
  const { email } = useApplicationContext();
  const { txaId } = useParams<{ txaId: string }>();
  const history = useHistory();

  return (
    <div className="quote-order-confirmation-container">
      <div className="order-confirmation-container" data-testid="ppc-order-confirmation">
        <div className="order-confirmation-container-atlassian-logo">{getAtlassianLogo('medium')}</div>
        <p className="order-confirmation-container-header">We have your order</p>
        {/* @ts-ignore */}
        {<img src={OrderConfirmation} className="order-confirmation-container-image" />}
        <div className="order-confirmation-container-description">
          <h5>
            {`We'll send you an email confirmation with all the details. You'll also receive an invoice within 24 hours.`}
          </h5>
          <div className="flex justify-center align-center gap3">
            <h5>The order number is {orderSlug}</h5>
            {showProvisionSiteCTA && (
              <Button
                appearance="default"
                onClick={() => {
                  onGetStarted && onGetStarted(getProvisioningUrl(newSiteOrderId, transactionAccountId, email));
                }}
              >
                Provision site now
              </Button>
            )}
          </div>
          <div className="flex justify-center align-center gap3 mt-32">
            <Button
              appearance="subtle"
              onClick={() => {
                history.push(getRouteUrl(routePaths.quotes, { txaId }));
              }}
            >
              Initiate a new order
            </Button>

            <Button
              appearance="primary"
              onClick={() => {
                history.push(getRouteUrl(routePaths.home, { txaId }));
              }}
            >
              Go back to home
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
